export default "__VITE_ASSET__DBXPUBI9__"